/**
 * Отступы и позиционирование
 *
 * v-[p|m|]-[t(op)|l(eft)|r(ight)|b(ottom)] = [value]
 * - padding/margin/pos = value для top/left/right/bottom
 *    - например:
 *      v-m-top="20" добавит margin-top: 20px в стили
 *      v-p-bottom="20" добавит padding-bottom: 20px в стили
 *      v-left="20" добавит left: 20px в стили
 *
 */
import { getFirstLetterInUppercase, getPxOrValue } from 'lib/utils/string';

export default (Vue) => {
  ['top', 'left', 'right', 'bottom', 'x', 'y'].forEach(bound => {
    Object.entries({
      m: 'margin',
      p: 'padding',
      '': '',
    }).forEach(([key, attribute]) => {
      const handler = function(el, { value }) {
        (
          ['x', 'y'].includes(bound)
            ? { x: ['left', 'right'], y: ['top', 'bottom'] }[bound]
            : [bound]
        )
          .forEach((item) => {
            // Если ключ есть, то просто сторона, иначе атрибутСторона
            el.style[
              key.length
                ? `${attribute}${getFirstLetterInUppercase(item)}`
                : item
            ] = getPxOrValue(value, value || '');
          });
      };

      // сокращение тоже можно
      [`${key}-${bound[0]}`, `${key}-${bound}`].forEach(idx => {
        Vue.directive(
          key.length ? idx : bound,
          {
            bind: handler,
            update: handler,
          }
        );
      });
    });
  });
};
